import { useEffect } from 'react';
import { ThemeMode } from '@xtreed/academy-shared';
import { useTenant } from '@/providers/TenantProvider';
import { usePWAStore } from '@/stores/pwa';
import {
  applyThemeClass,
  resolveTheme,
  tenantThemeMode,
} from '@/lib/theme-mode';

export function useStudentTheme() {
  const tenant = useTenant();
  const preference = usePWAStore((state) => state.themePreference);
  const setPreference = usePWAStore((state) => state.setThemePreference);

  const mode = tenantThemeMode(tenant?.themeMode);
  const theme = resolveTheme(mode, preference);

  useEffect(() => {
    applyThemeClass(theme);
  }, [theme]);

  return {
    isDark: theme === 'dark',
    canToggle: mode === ThemeMode.STUDENT_CHOICE,
    toggle: () => setPreference(theme === 'dark' ? 'light' : 'dark'),
  };
}
